// extracted by mini-css-extract-plugin
export var upgradeDisclaimerContainer = "UpgradeDisclaimer_upgradeDisclaimerContainer__CVzYZ";